import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Table } from 'antd-v5';
import InquiryExpandedRow from './InquiryExpandedRow';

const InquiryTable = ({ data, loading, onEdit, page, pageSize, total, onPageChange }) => {
  const history = useHistory();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const handleExpandRow = useCallback((expanded, record) => {
    if (expanded) {
      setExpandedRowKeys(prev => [...prev, record.id]);
    } else {
      setExpandedRowKeys(prev => prev.filter(key => key !== record.id));
    }
  }, []);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'clientName',
      key: 'clientName',
      sorter: (a, b) => a.clientName.localeCompare(b.clientName),
      render: (text, record) => (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <span
          className="inquiry-cell-name"
          onClick={() => history.push(`/Clients?client=${record.clientId}&clientTab=rolex`)}
        >
          {text}
        </span>
      ),
    },
    {
      title: 'Inquiry Date',
      dataIndex: 'inquiryDate',
      key: 'inquiryDate',
      sorter: (a, b) => a.inquiryDate.localeCompare(b.inquiryDate),
      render: (text, record) => (
        <div className="inquiry-cell-date">
          <span className="inquiry-cell-date__value">{text}</span>
          <span className="inquiry-cell-date__duration">{record.durationMonths}</span>
        </div>
      ),
    },
    {
      title: 'Product',
      dataIndex: 'productName',
      key: 'productName',
      render: (text, record) => (
        <div className="inquiry-cell-product">
          {record.productImage && (
            <img className="inquiry-cell-product__image" src={record.productImage} alt={record.productMpn} />
          )}
          <div className="inquiry-cell-product__info">
            <span className="inquiry-cell-product__name">{text}</span>
            <span className="inquiry-cell-product__mpn">
              {record.productMpn}
              {record.productCount > 1 && (
                <span className="inquiry-cell-product__more"> +{record.productCount - 1} more</span>
              )}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: 'Last Inbound',
      dataIndex: 'lastInbound',
      key: 'lastInbound',
      sorter: (a, b) => a.lastInbound.localeCompare(b.lastInbound),
      render: (text, record) => (
        <div className="inquiry-cell-date">
          <span className="inquiry-cell-date__value">{text}</span>
          <span className="inquiry-cell-date__duration">{record.lastInboundDuration}</span>
        </div>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: value => {
        const label = { WAITING: 'Waiting', ORDERED: 'Ordered', CANCELLED: 'Cancelled', FULFILLED: 'Fulfilled' };
        return label[value] || value;
      },
    },
    {
      title: '',
      key: 'edit',
      width: 60,
      render: (_, record) => (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <span className="inquiry-cell-edit" onClick={() => onEdit(record)}>
          Edit
        </span>
      ),
    },
  ];

  return (
    <div className="rolex-inquiries__table">
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        expandable={{
          // eslint-disable-next-line react/no-unstable-nested-components
          expandedRowRender: record => <InquiryExpandedRow inquiry={record} />,
          expandedRowKeys,
          onExpand: handleExpandRow,
        }}
        pagination={{
          current: page,
          pageSize,
          total,
          onChange: onPageChange,
          showSizeChanger: false,
        }}
        size="middle"
      />
    </div>
  );
};

export default InquiryTable;
